const sectionStyle = {
  maxWidth: "900px",
  margin: "0 auto",
  padding: "60px 20px"
};

const gridStyle = {
  display: "grid",
  gridTemplateColumns: "repeat(auto-fit, minmax(260px, 1fr))",
  gap: "20px"
};

const cardStyle = {
  border: "1px solid #eee",
  borderRadius: "12px",
  padding: "20px",
  background: "#fff",
  boxShadow: "0 10px 25px rgba(0,0,0,0.05)",
  transition: "all 0.2s ease"
};

const hoverEffect = (e, enter = true) => {
  e.currentTarget.style.boxShadow = enter
    ? "0 15px 35px rgba(0,0,0,0.1)"
    : "0 10px 25px rgba(0,0,0,0.05)";
  e.currentTarget.style.transform = enter
    ? "translateY(-3px)"
    : "translateY(0)";
};

const AwsAiPractitioner = () => {
  return (
    <div>

      {/* HERO */}
      <div style={{ ...sectionStyle, paddingTop: "80px" }}>
        <h1 style={{ fontSize: "36px", marginBottom: "20px" }}>
          Expanding into AI on AWS
        </h1>

        <p style={{ fontSize: "18px", color: "#555", maxWidth: "700px" }}>
          With the AWS Certified AI Practitioner certification, I’m extending my capabilities
          to design and implement AI-powered solutions integrated into real-world cloud systems.
        </p>
      </div>


      {/* IMAGE */}
      <div style={{ ...sectionStyle, paddingTop: "0", textAlign: "center" }}>
        <img
          src="/images/awsAiPractitionerBadge.png"
          alt="AWS Certified AI Practitioner"
          style={{
            width: "100%",
            maxWidth: "280px",
            borderRadius: "12px",
            boxShadow: "0 15px 40px rgba(0,0,0,0.15)"
          }}
        />

        <div style={{ fontSize: "14px", color: "#777", marginTop: "10px" }}>
          AWS Certified AI Practitioner
        </div>
      </div>


      {/* INTRO */}
      <div style={sectionStyle}>
        <p style={{ marginBottom: "20px", lineHeight: "1.7" }}>
          This certification strengthens my ability to work with modern AI services on AWS
          and integrate them into scalable, production-ready architectures.
        </p>

        <p style={{ lineHeight: "1.7" }}>
          More importantly, it reflects a practical approach — using AI where it creates measurable business value,
          not just as a trend.
        </p>
      </div>


      {/* CAPABILITIES 🔥 */}
      <div style={{ ...sectionStyle, background: "#fafafa" }}>
        <h2 style={{ marginBottom: "25px" }}>
          AI Capabilities I Can Deliver
        </h2>

        <div style={gridStyle}>
          {[
            "Designing generative AI applications using Amazon Bedrock",
            "Building intelligent document processing pipelines with Textract",
            "Integrating AI into serverless architectures and workflows",
            "Designing AI-enhanced APIs and backend services",
            "Automating business processes with AI-driven decision logic",
            "Combining AI services with scalable AWS infrastructure",
            "Designing event-driven AI pipelines",
            "Ensuring security and cost control in AI workloads",
            "Evaluating when and how AI should be applied in real systems"
          ].map((item, i) => (
            <div
              key={i}
              style={cardStyle}
              onMouseEnter={(e) => hoverEffect(e, true)}
              onMouseLeave={(e) => hoverEffect(e, false)}
            >
              ✓ {item}
            </div>
          ))}
        </div>
      </div>


      {/* USE CASES (VERY IMPORTANT 🔥) */}
      <div style={sectionStyle}>
        <h2 style={{ marginBottom: "25px" }}>
          Where This Creates Real Value
        </h2>

        <div style={gridStyle}>
          {[
            "Intelligent document processing (invoices, CVs, contracts)",
            "AI-powered data extraction and classification",
            "Automation of manual business workflows",
            "AI-assisted internal tools and dashboards",
            "Enhancing existing systems with AI capabilities",
            "Building new AI-driven applications from scratch"
          ].map((item, i) => (
            <div
              key={i}
              style={cardStyle}
              onMouseEnter={(e) => hoverEffect(e, true)}
              onMouseLeave={(e) => hoverEffect(e, false)}
            >
              {item}
            </div>
          ))}
        </div>
      </div>


      {/* POSITIONING */}
      <div style={sectionStyle}>
        <p style={{ lineHeight: "1.7", marginBottom: "20px" }}>
          My focus is on combining cloud architecture, software engineering, and AI into
          cohesive, production-ready systems — not isolated prototypes.
        </p>

        <p style={{ lineHeight: "1.7" }}>
          This means designing solutions that are scalable, maintainable, and aligned with real business needs.
        </p>
      </div>


      {/* CTA 🔥 */}
      <div style={{
        textAlign: "center",
        margin: "80px 0",
        padding: "50px 20px",
        background: "#fafafa"
      }}>
        <h2 style={{ marginBottom: "15px" }}>
          Explore AI Opportunities in Your AWS System
        </h2>

        <p style={{ color: "#555", marginBottom: "25px" }}>
          Let’s identify where AI can bring real value to your architecture.
        </p>

        <a
          href="/contact"
          style={{
            display: "inline-block",
            padding: "14px 32px",
            background: "#007bff",
            color: "#fff",
            borderRadius: "8px",
            textDecoration: "none",
            fontWeight: "500",
            boxShadow: "0 8px 20px rgba(0,0,0,0.1)",
            transition: "all 0.2s ease"
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.transform = "translateY(-2px)";
            e.currentTarget.style.boxShadow = "0 12px 30px rgba(0,0,0,0.15)";
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.transform = "translateY(0)";
            e.currentTarget.style.boxShadow = "0 8px 20px rgba(0,0,0,0.1)";
          }}
        >
          Discuss Your AI Use Case →
        </a>
      </div>

    </div>
  );
};

export default AwsAiPractitioner;